import {
    useRoutes
}                       from "react-router-dom";
import ConnectApple     from 'ui/pages/ConnectApple';
import Dashboard        from "ui/components/Dashboard";
import Profile          from "ui/pages/Profile";
import Classes          from 'ui/pages/Classes';
import ClassView        from "ui/pages/ClassView";
import FormSignin       from "ui/pages/FormSignin";
import FormNewTeacher   from "ui/pages/FormNewTeacher";
import EmailSent        from "ui/pages/EmailSent";
import CreateClass      from "ui/pages/CreateClass";
import TeacherStats     from "ui/pages/TeacherStats";
import OrganizationStats from "ui/pages/OrganizationStats";
import AllClassReports  from "ui/pages/AllClassReports";
import ClassReports     from "ui/pages/ClassReports";
import OrganizationReports from "ui/pages/OrganizationReports";
import WeeklyReportHandler from "ui/pages/WeeklyReportHandler";
import RoleBasedRedirect from "ui/components/RoleBasedRedirect";
import RoleBasedRoute from "ui/components/RoleBasedRoute";
import useMediaQuery    from "@mui/material/useMediaQuery";
import useTheme         from '@mui/material/styles/useTheme';

export default function Routes() {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));
    return useRoutes([
        {   path: '/signin',       element: <FormSignin />   },
        {   path: '/signup',       element: <FormSignin />   },
        // for backwards compatibility
        {   path: '/form-signin',       element: <FormSignin />   },
        {   path: '/signin-with-email', element: <FormSignin />   },
        {   path: '/form-new-teacher',  element: <FormNewTeacher /> },
        {   path: '/email-sent',        element: <EmailSent />   },
        {   path: '/apple',             element: <ConnectApple /> },
        {   path: '/classes',
            element: <Dashboard drawerOpen={matches}/>,
            children: [
                {   path: '',    element: <Classes />  },
                {   path: ':id', element: <ClassView /> },
            ]
        },
        {   path: '/reports',
            element: <RoleBasedRoute allowedRoles={['teacher']}><Dashboard drawerOpen={matches}/></RoleBasedRoute>,
            children: [
                {   path: '',    element: <AllClassReports />  },
                {   path: ':classId', element: <ClassReports /> },
            ]
        },
        {   path: '/organization-reports',
            element: <RoleBasedRoute allowedRoles={['manager']}><Dashboard drawerOpen={matches}/></RoleBasedRoute>,
            children: [
                {   path: '',    element: <OrganizationReports />  },
            ]
        },
        {   path: '/',
        element: <Dashboard/>,
        children: [
                {   path: 'profile',        element: <Profile />  },
                {   path: 'create-class',   element: <RoleBasedRoute allowedRoles={['teacher']}><CreateClass /></RoleBasedRoute>  },
                {   path: 'teacher_stat/:reportId', element: <RoleBasedRoute allowedRoles={['teacher', 'manager']}><TeacherStats /></RoleBasedRoute>  },
                {   path: 'organization_stat/:reportId', element: <RoleBasedRoute allowedRoles={['manager']}><OrganizationStats /></RoleBasedRoute>  },
                {   path: 'weekly-report',  element: <WeeklyReportHandler />  },
                {   path: '/',              element: <RoleBasedRedirect /> },
            ]
        },
        // { path: '*', element: <RoleBasedRedirect /> }
    ]);
}